import { DateTime } from 'luxon'

type Slot = {
  id: string
  opening_hour: string // "YYYY-MM-DD HH:mm:ss" or ISO 8601
  closing_hour: string // "YYYY-MM-DD HH:mm:ss" or ISO 8601
  remaining_capacity: number
  bookable?: boolean
}

type GroupedSlots = {
  date: string
  slots: Slot[]
}

export function groupSlotsByDay(slots: Slot[]): GroupedSlots[] {
  const groupedByDay: Record<string, Slot[]> = {}

  slots.forEach((slot) => {
    const parsedSql = DateTime.fromSQL(slot.opening_hour, { zone: 'Europe/Paris' })
    const isoDate = parsedSql.isValid
      ? parsedSql.toISODate()
      : DateTime.fromISO(slot.opening_hour, { zone: 'Europe/Paris' }).toISODate()
    const date = isoDate ?? slot.opening_hour.slice(0, 10)

    if (!groupedByDay[date]) {
      groupedByDay[date] = []
    }

    groupedByDay[date].push(slot)
  })

  return Object.entries(groupedByDay).map(([date, slots]) => ({
    date,
    slots,
  }))
}
